import axios from "../../../utils/axios";
import { IAddRemarkCode } from "../types/remark-codes.types";

// Endpoint to get remark codes
export async function getRemarkCodes(searchString?: string) {
    const response = await axios.get(`/payment/remark-codes`, {
        params: { search_string: searchString },
    });

    return response.data;
}

// Endpoint to add remark code
export async function addRemarkCode(payload: IAddRemarkCode) {
    const response = await axios.post(`/payment/remark-codes`, payload);

    return response.data;
}

// Endpoint to edit remark code
export async function editRemarkCode(codeId: string, payload: IAddRemarkCode) {
    const response = await axios.patch(
        `/payment/remark-codes/${codeId}`,
        payload
    );

    return response.data;
}

// Endpoint to delete remark code
export async function deleteRemarkCode(codeId: string) {
    const response = await axios.delete(`/payment/remark-codes/${codeId}`);

    return response.data;
}
